import { useContext } from "react"
import * as React from "react"
import { Context } from "../../../store/store"
import ElemCheckboxMafo from "../../elements/CheckboxMafo"

interface MafoQuestionProps {
	formElementChanged: Function
	validation: Object
}
const MafoQuestionThree: React.FC<MafoQuestionProps> = ({ formElementChanged, validation }) => {
	const { globalState } = useContext(Context)
	return (
		<>
			<h3 className="mb-2 text-center font-Alpro  text-[24px] text-blue lg:text-center lg:text-[32px]">Kaufst Du zum ersten Mal
				pflanzliche Joghurt-Alternativen?*  </h3>
			<div className="mx-auto grid grid-cols-1 flex-row text-left lg:max-w-[75%]">
				<ElemCheckboxMafo
					label={<>Ja</>}
					props={{
						type: "radio",
						name: "question3",
						required: true,
						value: "a",
						onClick: e => formElementChanged(e, "question3"),
					}}
					hasError={validation["invalid_question3"] ? true : false}
					className=" pb-2 text-green"
					errMsg={validation["invalid_question3_errMsg"] || ""}
				/>
				<ElemCheckboxMafo
					label={<>Nein</>}
					props={{
						type: "radio",
						name: "question3",
						required: true,
						value: "b",
						onClick: e => formElementChanged(e, "question3"),
					}}
					hasError={validation["invalid_question3"] ? true : false}
					className=" pb-2 text-green"
					errMsg={validation["invalid_question3_errMsg"] || ""}
				/>
			</div>
		</>
	)
}

export default MafoQuestionThree
